<!-- <div class="row header-bg usr-dfn-menu"> -->
    <!--div class="col-md-12 collapse navbar-collapse"  id ="submenu">
      <ul class="nav nav-pills flex-row d-custom" >
        <li class="nav-item">
          <a href="#" class=" nav-link "> <i class="fa fa-home fa-home"></i>&nbsp;Home</a>
        </li>
        <li class="nav-item">
          <a class="active nav-link  font-weight-bold text-dark" href="#">Menu 1</a>
        </li>
        <li class="nav-item">
          <a href="#" class="nav-link">Menu 2</a>
        </li>
      </ul>
	  <ul class="nav nav-pills flex-column d-block d-md-none" >
			<li class="nav-item">
			  <a href="#" class="active nav-link text-dark font-weight-bold"><i class="fa fa-home fa-home"></i>&nbsp;Home</a>
			</li>
			<li class="nav-item">
			  <a class="nav-link" href="#">Menu 1</a>
			</li>
			<li class="nav-item">
			  <a href="#" class="nav-link">Menu 2</a>
			</li>
		</ul>
    </div-->
	<!-- <div class="navbar-inverse side-collapse sidebar-custom in">
	  <nav role="navigation" class="navbar-collapse">
		<ul class="nav navbar-nav">
		  <li class="nav-item"><a class="nav-link" (click)="goHome()">Home</a></li>
		  <li class="nav-item"><a class="nav-link" (click)="goUsers()">Users</a></li>
		  <li class="nav-item"><a class="nav-link" (click)="getRoles()">Role Permission</a></li>
		  <li class="nav-item"><a class="nav-link" (click)="goProject()">Project</a></li>
		  <li class="nav-item"><a class="nav-link" (click)="goApplication()">Application</a></li>
		  <li class="nav-item"><a class="nav-link" (click)="goAccesslevel()">Access Level</a></li>
		</ul>
	  </nav>
	</div>
</div> -->



<div class="sidebar" id="navbarCollapse" *ngIf="isUserLoggedIn">
	<ul class="sidebar-menu">
		<li class="nav-item" ><a class="nav-link" (click)="goHome()"><i class="fa fa-home"></i> Home</a></li>
		<li class="nav-item" *ngIf="this.userNumber=='0'"><a class="nav-link" (click)="goUsers()"><i class="fa fa-user"></i> Users</a></li>
		<!-- <li class="nav-item"><a class="nav-link" (click)="getRoles()"><i class="fa fa-cogs"></i> Role Permission</a></li> -->
		<!-- <li class="nav-item"><a class="nav-link" (click)="goProject()"><i class="fa fa-pencil-square-o"></i> Project</a></li> -->
		<!-- <li class="nav-item"><a class="nav-link" (click)="goApplication()"><i class="fa fa-desktop"></i> Application</a></li> -->
		<li class="nav-item" *ngIf="this.accesslevelNumber=='0'"><a class="nav-link" (click)="goAccesslevel()"><i class="fa fa-cogs"></i> Access Level</a></li>  
	</ul> 	
</div>